/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
/// REACT ///
import { useEffect } from "react";
import { useState } from "react";
/// ACTIONS ///
import { restore } from "api/actions/history";
import { updateCooktop } from "api/actions/sketch/cooktop";
import { createRestorePoint } from "api/actions/history";
import { replaceRestorePoint } from "api/actions/history";
import { updateLocalCooktop } from "api/actions/sketch/cooktop";
import { markQuoteChanged } from "api/actions/quotes/quote";
/// TYPES ///
import { CutoutError } from "api/types/sketch";
import { Cooktop } from "api/types/sketch";
/// COMPONENTS ///
import SaveCooktop from "components/quote/drawer/cooktop";
/// FUNCTIONS ///
import { IHistoryActionType } from "api/types/history";

interface Props {
  selected_cooktop: Cooktop,
  setSelectedCooktop: (cooktop: Cooktop | null) => void,
  open: boolean,
  setOpen: (open: boolean) => void
}

export default function UpdateStoreCooktop({
  selected_cooktop,
  setSelectedCooktop,
  open,
  setOpen
}: Props) {
  const dispatch = useAppDispatch();
  const { quote } = useAppSelector(state => state.quote);
  const [cooktop, setCooktop] = useState<Cooktop>({});
  const [error, setError] = useState<CutoutError>({});

  useEffect(() => {
    if (open && selected_cooktop) {
      setCooktop(selected_cooktop);
      dispatch(replaceRestorePoint(
        {
          undo_action: IHistoryActionType.UPDATE_COOKTOP,
          desc: "Cancel Update Cooktop",
          undo_data: { ...selected_cooktop }
        }
      ));
    }
  }, [open]);

  const update = (cooktop: Cooktop) => {
    dispatch(updateLocalCooktop(cooktop));
    setCooktop(cooktop);
  }

  const cancel = () => {
    dispatch(restore());
    setOpen(false);
    setError({});
  }

  const save = () => {
    let error: CutoutError = {};
    if (!cooktop?.length) {
      error.length_error = "Length must be greater than 0";
      error.length_has_error = true;
    }

    if (!cooktop?.width) {
      error.width_error = "Width must be greater than 0";
      error.width_has_error = true;
    }

    if (error.width_error || error.length_error) {
      setError(error);
      return;
    }

    dispatch(updateCooktop(cooktop, cooktop.id));
    dispatch(markQuoteChanged(quote?.id));

    dispatch(createRestorePoint(
      {
        undo_action: IHistoryActionType.UPDATE_COOKTOP,
        redo_action: IHistoryActionType.UPDATE_COOKTOP,
        desc: "Change Cooktop Cutout",
        undo_data: { ...selected_cooktop },
        redo_data: cooktop
      }
    ));
    setSelectedCooktop(null);
    setOpen(false);
  }


  return (
    <SaveCooktop
      open={open}
      setOpen={setOpen}
      num_burners={cooktop?.num_burners ?? 0}
      setNumBurners={(num_burners => update({ ...cooktop, num_burners }))}
      length={cooktop?.length ?? 30}
      setLength={length => update({ ...cooktop, length })}
      length_error={error?.length_error ?? ""}
      length_has_error={error?.length_has_error ?? false}
      width={cooktop?.width ?? 26}
      setWidth={width => update({ ...cooktop, width })}
      width_error={error?.width_error ?? ""}
      width_has_error={error?.width_has_error ?? false}
      save={save}
      cancel={cancel}
      title="Edit Cooktop Cutout" />
  );
}
